import React, {useCallback, useEffect, useMemo, useState} from "react";
//import { DefaultColumnFilter, Filter} from './filters';
import {useTranslation} from "react-i18next";
import {usePagination, useSortBy, useTable} from "react-table";
import {Col, CustomInput, Input, Row, Table} from "reactstrap";
import Aux from "../../../hoc/Auxiliary";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr-CA';
import {debounce} from "lodash";
import Spinner from "../../UI/Spinner";
import SearchForm from "../../UI/SearchForm/SearchForm";
import SelectWrapper from "../../Utils/Input/SelectWrapper";
import Sorter from "../../UI/Toolbar/Sorter";
import DateFilters from "../../Accounts/Account/Tables/DateFilters";
import {fireGTMDownloadFileEvent} from "../../Utils/GTM/GTMHelper";

const findObject = (obj = {}, query) => {
    for (const [key, value] of Object.entries(obj)) {
        if (typeof value === "string") {
            if (value.toLowerCase().includes(query.toLowerCase())) {
                return true;
            }
        }
    }
    return false;
};

const InvoiceTable = ({
                          columns,
                          data,
                          loading,
                          checked,
                          showExportPdf,
                          showExportXml,
                          showUnpaid,
                          doXLSExport,
                          doXLSDetailExport,
                          doPDFExport,
                          startDate,
                          setStartDate,
                          endDate,
                          setEndDate,
                          accountTypes,
                          accountType,
                          setAccountType,
                          getSortedItems,
                          sorterValues,
                          initialSortField,
                          onPage,
                          setDateFilterType,
                          dateFilterType,
                          initialPageIndex,
                          labelFilterAll,
						  searchData,
						  setSearchData
                      }) => {
    const {t, i18n} = useTranslation();
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [filters, setFilters] = useState({unPaid: false});
    const [sortField, setSortField] = useState(initialSortField);
    const [sortDirection, setSortDirection] = useState('DESC');
    const [sortTableField, setSortTableField] = useState(initialSortField);
    const [sortTableDirection, setSortTableDirection] = useState('DESC');

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        setSortBy,
        rows,
        state: {pageIndex, pageSize, sortBy},
    } = useTable(
        {
            columns,
            data: searchData,
            rows,
            initialState: {
                pageIndex: initialPageIndex ? initialPageIndex : 0,
                pageSize: 10,
                sortBy: [{id: sortField, desc: sortDirection === 'DESC' ? true : false}],
            },
            disableSortRemove: true,
        },
        useSortBy,
        usePagination
    );

    useEffect(() => data && setSearchData(mapFiltered()), [data, filters]);

    const handleSearch = debounce((query) => {
        if (!query) {
            setSearchData(mapFiltered());
            return;
        }
        const searchData = mapFiltered().filter((item) => findObject(item, query));
        setSearchData(searchData);
        return;
    }, 300);

    const typeFilterHandler = (filter, value) => {
        const newFilters = {...filters, [filter]: value}
        setFilters(newFilters)
    }
    const setSorterCallback = (columnId, direction) => {
        setSortTableField(columnId)
        setSortTableDirection(direction)
    }

    useEffect(() => {
        if (sortBy.length > 0) {
            setSortField(sortBy[0].id);
            setSortDirection(sortBy[0].desc ? 'DESC' : 'ASC')
        }
    }, [sortBy])

    const setSortByCallback = useMemo(() =>
            [{desc: sortTableDirection === 'DESC', id: sortTableField}]
        , [sortTableDirection, sortTableField])

    useEffect(() => {
        if (setSortByCallback.length) {
            setSortBy(setSortByCallback)
        }
    }, [setSortByCallback]);

    useEffect(() => {
        onPage && onPage(pageIndex);
    }, [pageIndex]);

    const generateSortingIndicator = (column) => {
        return column.isSorted ? (
            column.isSortedDesc ? (
                <i className="fa fa-angle-down"></i>
            ) : (
                <i className="fa fa-angle-up"></i>
            )
        ) : (
            ""
        );
    };

    const onChangeInSelect = (event) => {
        setPageSize(Number(event.target.value));
    };

    const onChangeInInput = (event) => {
        const page = event.target.value ? Number(event.target.value) - 1 : 0;
        gotoPage(page);
    };

    const onDownloadClick = async () => {
        setLoadingPdf(true)
        await doPDFExport()
		fireGTMDownloadFileEvent('facture','PDF');
        setLoadingPdf(false)
    };

    const mapFiltered = () => {
        let filteredData = data.filter(item => {
            let isMatching = true;
            Object.entries(filters).forEach(entry => {
                const [key, value] = entry;
                if (value) {
                    switch (key) {
                        case 'unPaid':
                            isMatching = item.transactionStatus.code !== 'P' && isMatching;
                            break;
                        default:
                            isMatching = true;
                    }
                }
            })

            return isMatching;
        });

        return filteredData;
    }

    return (
        <Aux>
            <div style={{maxWidth: "935px"}}
                 className="flex flex-column section--padding--bottom--0 section--invoices">
                <div className="search-form flex">
                    <div className="flex flex-grow-1 align-items-center">
                        <input
                            type="text"
                            className="form-control"
                            id="search"
                            aria-label="Search"
                            placeholder={t(`docs.invoices.table.search_placeholder`)}
                            onChange={(v) => handleSearch(v.target.value)}
                        />
                        <i className="far fa-search"></i>
                    </div>
                </div>
                <div className="mt-3 mt-sm-2 mb-2">
                    <DateFilters
                        startDate={startDate}
                        endDate={endDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        changeDateFilterType={setDateFilterType}
                        dateFilterType={dateFilterType}
                        enableCurrentPeriod={false}
                        component={null}
                        labelFilterAll={labelFilterAll}
                    />
                </div>
            </div>
            <div>

                <div className="form-group flex flex-column flex-lg-row justify-content-between mw-100">
                    <div
                        className="flex flex-column flex-sm-row flex-md-wrap justify-content-start align-items-stretch align-items-md-end">

                        {accountTypes.length > 0 && searchData.length > 0 ? (
                            <Aux>
                                <strong
                                    className="align-self-start align-self-sm-center align-self-md-center justify-self-center mr-2 ">
                                    {t("docs.invoices.table.filter.title")}
                                </strong>
                                <SelectWrapper>
                                    <select id="account-filters"
                                        onChange={(e) => {
                                            let selectValue = e.target.value;
                                            setAccountType(selectValue)
                                        }}
                                        value={accountType}
                                    >
                                        <option value="">{t("docs.invoices.table.filter.account_type.label")}</option>
                                        {accountTypes.map(type => {
                                            return (
                                                <option value={type} key={type}>
                                                    {t(`docs.invoices.table.filter.account_type.${type}`)}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </SelectWrapper>
                            </Aux>


                        ) : null}
                    </div>

                    {showUnpaid ? (
                        <div
                            className="flex flex-column flex-sm-row flex-md-wrap  justify-content-start align-items-stretch align-items-md-center">
                            <label className="checkbox-field checkbox-field--gray mt-3 mt-md-0" htmlFor="unpaid_only">
                                <input type="checkbox" name="unpaid_only" id="unpaid_only"
                                       checked={filters.unPaid}
                                       onChange={(e) => typeFilterHandler('unPaid', e.target.checked)}/>
                                <span></span>
                                <strong>&nbsp;&nbsp;{t('docs.invoices.table.filter.unpaid_only')}</strong>
                            </label>
                        </div>
                    ) : ''}
                </div>


                {loading ?
                    <Spinner/>
                    :
                    <React.Fragment><br/><h3 className="headline headline--block headline--margin--0 ">
                        {searchData.length} {t("docs.invoices.table.search_results")}
                    </h3></React.Fragment>}
                <br/>
            </div>
            {searchData.length > 0 ? <Aux>
                    <div className="flex flex-row flex-wrap justify-content-between">
                        <div className={`btn-export-xls ${(!showExportPdf && !showExportXml)  ? 'mb-0 mb-md-5' : ''}`}>
                            {showExportPdf || showExportXml ? <img
                                className="specialarrow"
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAVCAYAAAC6wOViAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAETSURBVHgB7ZYxjoJAFIbfoPRuSWg4woRAQrd6AvcKewNvIJ5g9wp7hD2B2tFA8AZ2tPQE8H8JNhMxg77Exi+BeUzmn28oGEbRHeI41l3X7VEuSIZDnucr596Itm3XgkLq+z7gdm45vsYCNvQ8J2spVliXZflHQjj0At7St1SEeRRFG3wSa9d1v7MsO08JP5p1ENqiXTZNs0+SJLANQpgi+zNkP2kCLN0NdWArHoS8WN44SuxW/zQBpyiKXwRTW7EpxA9hhd2qpilSvkG8sxFLCJnZtaiq6uh5HimllnhcYMIv1DyhxlX7vv8hIWSU2RGG4RaydCzwrJCZmR3GG4sLb0rHxFLCUakplhRaobUWO65cuQA3T9LjPVThWAAAAABJRU5ErkJggg=="
                            /> : null}
                            {showExportPdf ?
                                <button
                                    disabled={checked && checked.length === 0}
                                    type="button"
                                    id="downloadPdf"
                                    className="btn btn-secondary mr-2 flex-grow-1 flex-md-grow-0"
                                    onClick={onDownloadClick}
                                >
                                    {loadingPdf ? t("docs.invoices.table.pdf_loading") : (
                                        <Aux>
                                            {t("docs.invoices.table.pdf_download")}
                                            &nbsp;&nbsp;
                                            <i className="far fa-file-download"></i>
                                        </Aux>
                                    )}
                                </button> : null
                            }
                            {showExportXml ?
                                <div className={doXLSDetailExport ? "dropdown" : "button"}>
                                    <button
                                        disabled={checked && checked.length === 0}
                                        className={`btn btn-secondary ${
                                            doXLSDetailExport ? "dropdown-toggle" : ""
                                        }`}
                                        type="button"
                                        id="dropdownMenuButton"
                                        data-toggle={doXLSDetailExport ? "dropdown" : ""}
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        onClick={doXLSDetailExport ? () => {
                                        } : () => doXLSExport()}
                                    >
                                        {t("docs.invoices.table.xls_download")}
                                        &nbsp;&nbsp;
                                        <i className="far fa-file-spreadsheet"></i>
                                    </button>
                                    {doXLSDetailExport ? (
                                        <>
                                            <div
                                                className="dropdown-menu"
                                                aria-labelledby="dropdownMenuButton"
                                            >
                                                <button
                                                    disabled={checked && checked.length === 0}
                                                    className="dropdown-item"
                                                    onClick={() => doXLSExport('xls')}
                                                >
                                                    {t("docs.invoices.table.xls_summary")}
                                                </button>
                                                <button
                                                    disabled={checked && checked.length === 0}
                                                    className="dropdown-item"
                                                    onClick={() => doXLSDetailExport('xls')}
                                                >
                                                    {t("docs.invoices.table.xls_detail")}
                                                </button>
                                                <button
                                                    disabled={checked && checked.length === 0}
                                                    className="dropdown-item"
                                                    onClick={() => doXLSExport('csv')}
                                                >
                                                    {t("docs.invoices.table.csv_summary")}
                                                </button>
                                                <button
                                                    disabled={checked && checked.length === 0}
                                                    className="dropdown-item"
                                                    onClick={() => doXLSDetailExport('csv')}
                                                >
                                                    {t("docs.invoices.table.csv_detail")}
                                                </button>
                                            </div>
                                        </>
                                    ) : null}
                                </div> : null}
                        </div>
                        <Sorter
                            sortOptions={sorterValues}
                            items={searchData}
                            getSortedItems={getSortedItems}
                            setSortByCallback={setSorterCallback}
                            sortDirection={sortDirection}
                            sortField={sortField}
                            currentDisplayMode='list'
                        />
                    </div>
                    <div className="nopadding overflow-hidden w-100 flex flex-column">
                        <Table
                            hover
                            {...getTableProps()}
                            style={{minWidth: "100%"}}
                            className="datatable datatable__responsive table-responsive w-100 "
                        >
                            <thead
                                className={
                                    data.length === 0 || loading
                                        ? "flex flex-row justify-content-between w-100"
                                        : ""
                                }
                            >
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>
                                            <div {...column.getSortByToggleProps({title: t(`docs.togglesortby`) + ' ' + column.render("Header")})}>
                                                {column.render("Header")}
                                                {generateSortingIndicator(column)}
                                            </div>
                                            {/*<Filter column={column} /> */}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>
                            {loading ? (
                                <tbody>
                                <tr>
                                    <td colSpan="100%">
                                        <div className="container flex flex-column justify-content-start align-items-start">
                                            <Spinner/>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            ) : <tbody {...getTableBodyProps()}>
                            {page.map((row) => {
                                prepareRow(row);
                                return (
                                    <Aux key={row.getRowProps().key}>
                                        <tr>
                                            {row.cells.map((cell) => {
                                                return (
                                                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                                );
                                            })}
                                        </tr>
                                    </Aux>
                                );
                            })}
                            </tbody>}
                        </Table>

                    </div>
                    <div className="datatable__actions">
                        <div className="datatable__actions__extras">
                            <Row className="flex--align-center">
                                <Col xs={6}>
                                    {t(`docs.pagination.page`)}{" "}
                                    <strong>
                                        {pageIndex + 1} {t(`docs.pagination.of`)} {pageOptions.length === 0 ? pageOptions.length + 1 : pageOptions.length}
                                    </strong>
                                </Col>
                                <Col xs={6} className="a-right">
                                    <CustomInput
                                        type="select"
                                        value={pageSize}
                                        id="row-range-select"
                                        onChange={onChangeInSelect}
                                    >
                                        {[10, 20, 30, 40, 50].map((pageSize) => (
                                            <option key={pageSize} value={pageSize}>
                                                {t(`docs.pagination.show`)} {pageSize}
                                            </option>
                                        ))}
                                    </CustomInput>
                                </Col>
                            </Row>
                        </div>
                        <div className="datatable__actions__base flex flex--justify-center">
                            <button
                                className="btn btn--table"
                                onClick={() => gotoPage(0)}
                                disabled={!canPreviousPage}
                            >
                                <i className="fas fa-angle-double-left"></i>
                            </button>
                            <button
                                className="btn btn--table"
                                onClick={previousPage}
                                disabled={!canPreviousPage}
                            >
                                <i className="fas fa-angle-left"></i>
                            </button>
                            <div>
                                <Input
                                    type="number"
                                    className="input-current-page"
                                    min={1}
                                    style={{width: 70}}
                                    max={pageOptions.length}
                                    value={pageIndex + 1}
                                    onChange={onChangeInInput}
                                />
                            </div>
                            <button
                                className="btn btn--table"
                                onClick={nextPage}
                                disabled={!canNextPage}
                            >
                                <i className="fas fa-angle-right"></i>
                            </button>
                            <button
                                className="btn btn--table"
                                onClick={() => gotoPage(pageCount - 1)}
                                disabled={!canNextPage}
                            >
                                <i className="fas fa-angle-double-right"></i>
                            </button>
                        </div>
                    </div>
                </Aux>
                : null}
        </Aux>
    );
};

export default InvoiceTable;
